import { render, staticRenderFns } from "./more-video.vue?vue&type=template&id=5f996d55&scoped=true&"
import script from "./more-video.vue?vue&type=script&lang=js&"
export * from "./more-video.vue?vue&type=script&lang=js&"
import style0 from "./more-video.vue?vue&type=style&index=0&id=5f996d55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f996d55",
  null
  
)

export default component.exports